import { createContext, useContext, useState, ReactNode } from "react";

interface LeadContextValue {
  leadId: string | null;
  setLeadId: (id: string) => void;
}

const LeadContext = createContext<LeadContextValue>({
  leadId: null,
  setLeadId: () => {},
});

export const LeadProvider = ({ children }: { children: ReactNode }) => {
  const [leadId, setLeadId] = useState<string | null>(null);

  return (
    <LeadContext.Provider value={{ leadId, setLeadId }}>
      {children}
    </LeadContext.Provider>
  );
};

export const useLeadContext = () => useContext(LeadContext);
